(app => {

    app.service("customFieldsDataTable",
        [
            "modalService", "customFieldApi", function (modalService, customFieldApi) {
                this.dataTableOptions = {
                    title: "Custom Fields"
                };

                this.buildDataTableOptions = (customFields, currentUser) => {
                    this.dataTableOptions = {
                        ...this.dataTableOptions,
                        headers: this.getHeaders(),
                        rows: customFields.map(customField => {
                            return {
                                cells: [
                                    customField.FieldName,
                                    this.spacer(customField.CustomFieldDomainType),
                                    this.spacer(customField.CustomFieldType),
                                    customField.DefaultValue,
                                    customField.PlaceHolder
                                ],
                                rowObject: customField,
                                state: {
                                    //name: "Home.Client",
                                    //params: { clientId: customField.Id }
                                },
                                rowActions: [
                                ]
                            };
                        }),
                        filters: [
                            {
                                index: 3,
                                label: "Field Type",
                                options: this.getStatusFilters(customFields)
                            }
                        ],
                        rowActions: [
                            {
                                title: "Edit Custom Field",
                                iconName: "mdi-pencil",
                                className: "btn-accent-sm",
                                action: this.editCustomField
                            },
                            {
                                title: "Delete Custom Field",
                                iconName: "mdi-delete",
                                className: "btn-warning",
                                action: this.deleteCustomField
                            }
                        ],
                        miscButtons: [
                            {
                                label: "Add New Custom Field",
                                action: this.addCustomField,
                                params: [
                                    currentUser
                                ]
                            }
                        ]
                    };

                    return this.dataTableOptions;
                };

                this.spacer = (text) => {
                    return text === 'Client'
                        ? "Contact (Personal)"
                        : text === 'DateTime' //TODO: replace if/when we add times to custom fields
                            ? "Date" 
                            : text.replace(/([A-Z])/g, ' $1');
                };

                this.getHeaders = () => {
                    return [
                        {
                            title: "Field Name",
                            type: "string"
                        },
                        {
                            title: "Location",
                            type: "string"
                        },
                        {
                            title: "Field Type",
                            type: "string"
                        },
                        {
                            title: "Default Value",
                            type: "string"
                        },
                        {
                            title: "Placeholder",
                            type: "string"
                        }
                    ];
                };

                this.removeDuplicateObjects = (arr) => {
                    return arr.filter((obj, index, self) => {
                        return index === self.findIndex(o => o.label === obj.label);
                    });
                };

                this.getStatusFilters = (customFields) => {
                    let statuses = customFields.map(customField => {
                        return {
                            selected: false,
                            label: customField.Status
                        };
                    });

                    return this.removeDuplicateObjects(statuses);
                };

                this.deleteCustomField = (customField, $event) => {
                    modalService.confirmCustomFieldDeletion(customField.FieldName, $event)
                        .then(() => {
                            customFieldApi.remove(customField)
                                .then(() => {
                                    const index = this.dataTableOptions.rows.findIndex(row => {
                                        return row.rowObject.Id === customField.Id;
                                    });

                                    this.dataTableOptions.rows.splice(index, 1);
                                })
                                .catch((error) => {
                                    console.log(error);
                                });
                        });
                };

                this.addCustomField = ($event, params) => {
                    modalService.openAddCustomField(params[0], $event);
                };
                this.editCustomField = (customField, $event) => {
                    modalService.openEditCustomField(customField, $event);
                };
            }
        ]);

})(window.app);